import React from "react";
import Routes from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-WJKTQXKN",
};

TagManager.initialize(tagManagerArgs);

const App = () => <Routes />;

export default App;
